(() => {
  const prefix = 'vendor:"Everything Cool Baby" AND ';
  window.ecBabySearchForTerm = term => window.ecBabySearch || /\bcribs?\b/i.test(term);
  window.ecBabySearchUrl = term => {
    const url = new URL((window.Shopify?.routes?.root || '/') + 'search', location.origin);
    let clean = term.replaceAll(prefix, '').replace(/[():"\\]/g, ' ').replace(/\b(?:AND|OR|NOT)\b/g, ' ').trim();
    if (/\bcribs?\b/i.test(clean)) {
      clean = 'title:crib ' + clean.replace(/\b(?:baby|cribs?)\b/gi, ' ').trim();
    }
    url.searchParams.set('q', prefix + clean.trim());
    url.searchParams.set('type', 'product');
    url.searchParams.set('options[prefix]', 'last');
    return url;
  };
  const current = new URL(location.href);
  const currentTerm = current.searchParams.get('q') || '';
  if (current.pathname.endsWith('/search') && !currentTerm.startsWith(prefix) && window.ecBabySearchForTerm(currentTerm)) {
    location.replace(window.ecBabySearchUrl(currentTerm));
    return;
  }
  document.querySelectorAll('form[role="search"] input[name="q"]').forEach(input => {
    input.value = input.value.replaceAll(prefix, '');
  });
  document.addEventListener('submit', event => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement)) return;
    const action = new URL(form.action, location.origin);
    if (!action.pathname.endsWith('/search')) return;
    const input = form.querySelector('input[name="q"]');
    if (!input || !input.value.trim() || !window.ecBabySearchForTerm(input.value)) return;
    if (form.querySelector('[aria-selected="true"] a')) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    location.assign(window.ecBabySearchUrl(input.value));
  }, true);
})();